// extracted by mini-css-extract-plugin
module.exports = {"Pagenation":"Pagenation_Pagenation__3Hkw9","PageNavText":"Pagenation_PageNavText__2f0SR","PageNav":"Pagenation_PageNav__3onuZ","PageNavActive":"Pagenation_PageNavActive__2DmEV"};